
import React from 'react';
import { Text } from 'react-native';

const Title = ({title}) => (
  <Text style={{ fontSize: 32,paddingTop:30,paddingBottom:30 }}>{title}</Text>
);

export default Title;